type TGetValues = Record<string, unknown>;
type TGetValuesKeys = keyof TGetValues;

type TGet = {
    /** Значение по умолчанию */
    defaultValue?: string;
    /** Путь до значения в объекте */
    path?: string;
    /** Основной объект */
    values: TGetValues;
};

/**
 * Получает значение по пути к объекту.
 * Если разрешенное значение `undefined`, вместо него возвращается значение `defaultValue`
 * @example
 * let object = { 'a': [{ 'b': { 'c': 3 } }] };
 * get(object, 'a[0].b.c'); // => 3
 * */
export const get = ({ defaultValue = '', path = '', values }: TGet): unknown => {
    const travel = (regexp: RegExp) =>
        String.prototype.split
            .call(path, regexp)
            .filter(Boolean)
            .reduce(
                (res: unknown, key: string) =>
                    res !== null && res !== undefined
                        ? (res as TGetValues)[key as TGetValuesKeys]
                        : res,
                values
            );

    const result =
        // последовательности из запятых, точек и/или квадратных скобок
        travel(/[,[\]]+/) ||
        // последовательности из запятых и/или квадратных скобок
        travel(/[,.[\]]+/);

    return result === undefined || result === values ? defaultValue : result;
};
